/**
 * Delete account handler.
 *
 * A theme replacement for the WP Delete User Accounts plugin. Posts to
 * admin-ajax and redirects home on success. No jQuery (hence not bundled).
 *
 * Unfortunately written in ES5 to fit the theme's gulp/uglify build pipeline.
 * Not worth the effort to write in ES6 and change the build pipeline.
 */

(function () {
  var form = document.getElementById('delete-account-form');

  if (!form || typeof njasDeleteAccount === 'undefined') {
    return;
  }

  var notice = form.querySelector('.delete-account-notice');
  var confirmInput = document.getElementById('delete-account-confirm');
  var nonceInput = document.getElementById('wp_delete_user_account_nonce');
  var submitButton = document.getElementById('delete-account-submit');

  function showNotice(message) {
    if (!notice) {
      return;
    }
    notice.textContent = message;
    notice.style.display = 'block';
  }

  function hideNotice() {
    if (notice) {
      notice.style.display = 'none';
    }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (confirmInput.value !== 'DELETE') {
      showNotice('That didn\'t match. Type DELETE exactly (uppercase) to continue.');
      return;
    }

    submitButton.disabled = true;
    hideNotice();

    var body = new URLSearchParams({
      action: 'wp_delete_user_account',
      confirm: confirmInput.value,
      wp_delete_user_account_nonce: nonceInput ? nonceInput.value : ''
    });

    fetch(njasDeleteAccount.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.success) {
          window.location.href = data.data.redirect_url;
          return;
        }

        submitButton.disabled = false;
        showNotice((data.data && data.data.message) || 'Something went wrong.');
      })
      .catch(function () {
        submitButton.disabled = false;
        showNotice('Something went wrong.');
      });
  });
})();
